<template>

	<button v-if="look=='sidebar'" type="button" class="button solid black wide small messenger"  :data-unread="unread" v-on:click="toggleMessenger()"><i class="fas fa-fw fa-comments"></i> Chat with Us</button>
	<button v-else-if="look=='dashboard'" type="button" class="button solid small messenger" :data-unread="unread"  v-on:click="toggleMessenger()"><i class="fas fa-fw fa-comments"></i> Chat with Us</button>
	<button v-else-if="look=='dashboard_mobile'" type="button" class="button medium textual inline messenger"  :data-unread="unread" v-on:click="toggleMessenger()">View</button>

</template>
<script>
import { mapGetters, mapActions } from 'vuex';
export default {

	props: [
		'uuid',
		'look',
		'unread'
	],

	data: () => {
		return {
		}
	},

	computed: {
	},

	watch: {
	},

	created() {
	},

	mounted() {
	},

	methods: {

		toggleMessenger: function(){
			this.$root.$refs.messenger.toggleMessenger(this.uuid);
		}

	}
};
</script>